// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"ebea1b77","453":"ed3810f9","605":"9dd1f9a9"}[chunkId] + ".chunk.js";
};